// /* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api"; 

export const add_customer_testimonial = createAsyncThunk(
    'home/add_customer_testimonial',
    async(info, { rejectWithValue,fulfillWithValue }) => {
        //console.log('info\n', info)
        try {
            const {data} = await api.post('/home/add-customer-testimonial', info) 
            // console.log('info ', info)
            // console.log('data ', data) 
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const get_customer_testimonials_by_frontEndURL = createAsyncThunk(
    'home/get_customer_testimonials_by_frontEndURL',
    async(frontEndURL ,{rejectWithValue, fulfillWithValue}) => {
        //console.log('get_seller_by_frontEndURL\n', frontEndURL)
        try {
            const {data} = await api.get(`/home/get-customer-testimonials-by-frontEndURL/${encodeURIComponent(frontEndURL)}`)
            //console.log('get_seller_by_frontEndURL data ', data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response.data)
            //return rejectWithValue(error.response.data)
        }
   }
)
// End Method 

export const customerTestimonialReducer = createSlice({
    name: 'customerTestimonial',
    initialState:{
        customerTestimonials: [],
        errorMessage : '',
        successMessage: '',  
        //myOrder : {}
    },
    reducers : {
        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
     extraReducers: (builder) => {
         builder
        .addCase(add_customer_testimonial.fulfilled, (state, { payload }) => { 
            state.successMessage = payload.message;
        })
        .addCase(add_customer_testimonial.rejected, (state, { payload }) => {
            state.errorMessage = payload.message;
        })
        .addCase(get_customer_testimonials_by_frontEndURL.fulfilled, (state, { payload }) => { 
            state.customerTestimonials = payload.customerTestimonials;
        })
        .addCase(get_customer_testimonials_by_frontEndURL.rejected, (state, { payload }) => {
            state.errorMessage = payload.message;
        })
     }
 })

export const {messageClear} = customerTestimonialReducer.actions
export default customerTestimonialReducer.reducer
